import React from 'react'
import { motion } from 'framer-motion'
import { FiArrowRight, FiZap, FiTarget } from 'react-icons/fi'

const FinalCTA = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id)
    if (element) {
      const offset = 80
      const bodyRect = document.body.getBoundingClientRect().top
      const elementRect = element.getBoundingClientRect().top
      const elementPosition = elementRect - bodyRect
      const offsetPosition = elementPosition - offset
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' })
    }
  }

  return (
    <section id="final-cta" className="relative py-40 px-4 sm:px-6 lg:px-8 bg-gray-50 overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent-maroon/5 blur-[160px] rounded-full pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-accent-maroon/30 to-transparent" />
      
      <div className="absolute inset-0 flex items-center justify-center opacity-[0.03] select-none pointer-events-none">
        <h2 className="text-[25vw] font-black font-grotesk tracking-tighter leading-none whitespace-nowrap text-gray-800">SAMRIDDHI</h2>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="bg-white/10 border border-gray-200 rounded-[3.5rem] p-12 md:p-24 backdrop-blur-2xl overflow-hidden relative group transition-all duration-700 hover:border-accent-maroon/30">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-accent-maroon/5 blur-[100px] rounded-full group-hover:opacity-100 transition-opacity" />

          <div className="max-w-4xl mx-auto text-center relative z-10">
            <motion.div initial={{ opacity: 0, scale: 0.8 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} className="inline-flex items-center space-x-3 bg-accent-maroon/10 border border-accent-maroon/30 px-6 py-2 rounded-full mb-12">
              <FiTarget className="text-accent-maroon animate-pulse" />
              <span className="text-accent-maroon font-black text-[10px] uppercase tracking-[0.4em]">Ready for action</span>
            </motion.div>

            <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-6xl md:text-[8rem] font-black font-grotesk tracking-tighter leading-[0.85] text-gray-800 mb-12">
              DON'T WAIT. <br />
              <span className="bg-gradient-to-r from-accent-maroon via-accent-maroonDark to-accent-maroon bg-clip-text text-transparent italic">BE THE CHANGE.</span>
            </motion.h2>

            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.3 }} className="text-gray-600 text-xl md:text-2xl font-medium mb-20 max-w-2xl mx-auto leading-relaxed">
              The transformation of Udaipur isn't a goal—it's a mission. Join 5,000+ changemakers rewriting the city's future.
            </motion.p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-8">
              <motion.button whileHover={{ scale: 1.05, boxShadow: "0 0 50px rgba(128,0,0,0.4)" }} whileTap={{ scale: 0.95 }} onClick={() => scrollToSection('volunteers')} className="group relative px-14 py-6 bg-accent-maroon text-white font-black uppercase tracking-[0.2em] text-sm rounded-2xl overflow-hidden shadow-2xl w-full sm:w-auto">
                <span className="relative z-10 flex items-center justify-center">
                  Join Movement
                  <FiArrowRight className="ml-3 transition-transform group-hover:translate-x-2" />
                </span>
                <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity" />
              </motion.button>

              <motion.button whileHover={{ scale: 1.05, backgroundColor: "rgba(128,0,0,0.1)" }} whileTap={{ scale: 0.95 }} onClick={() => scrollToSection('missions')} className="group flex items-center justify-center space-x-3 px-14 py-6 bg-white/10 border border-gray-200 rounded-2xl text-gray-800 font-black uppercase tracking-[0.2em] text-sm transition-all w-full sm:w-auto">
                <FiZap className="text-accent-maroon" />
                <span>Active Drives</span>
              </motion.button>
            </div>

            <div className="mt-24 pt-12 border-t border-gray-200 flex flex-col md:flex-row items-center justify-center gap-12">
              <div className="flex items-center space-x-4">
                <div className="flex -space-x-4">
                  {[...Array(4)].map((_, i) => (
                    <div key={i} className="w-10 h-10 rounded-full border-2 border-white overflow-hidden bg-gray-200">
                      <img src={`https://i.pravatar.cc/100?img=${i+10}`} alt="Volunteer" />
                    </div>
                  ))}
                </div>
                <p className="text-[10px] font-black text-gray-600 uppercase tracking-widest">+5K Active Now</p>
              </div>
              
              <div className="h-px md:h-8 w-12 md:w-px bg-gray-300" />
              
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 rounded-full bg-accent-maroon animate-pulse" />
                <p className="text-[10px] font-black text-gray-800 uppercase tracking-widest italic">Live from Lake Pichola</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FinalCTA